import { all, takeEvery, put, call } from "redux-saga/effects";
import actions from "./actions";
import { axiosPrivate } from "../../Helpers/axios";

function* getCategoryDetailsResponse({ payload: { agentId } }) {
  try {
    const response = yield call(
      axiosPrivate,
      `/api/cou-dashboard/agents/transaction-details/${agentId}` // ✅ correct endpoint
    );

    console.log("📡 Saga response:", response.data);

    yield put(actions.getCategoryDetailsSuccess(response.data)); // ✅ send array directly
  } catch (error) {
    yield put(
      actions.getCategoryDetailsFailed(
        error.response?.data?.message || error.message
      )
    );
  }
}

export default function* categorySaga() {
  yield all([takeEvery(actions.GET_CATEGORY_DETAILS, getCategoryDetailsResponse)]);
}
